export enum InvoiceExtractionStatus {
    UPLOADED = 'UPLOADED',
    PENDING = 'PENDING',
    RUNNING = 'RUNNING',
    PROCESSING = 'PROCESSING',
    SUCCESS = 'SUCCESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
}
